const HEART_SRCS = [
  "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/6qqn30ef_1.png",
  "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/73su0adi_2.png",
  "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/kd94k1zl_3.png",
  "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/gyl5qsfo_4.png",
  "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/2ekcxat3_5.png",
];

/**
 * Hand-drawn scrapbook heart. Uses one of 4 provided PNGs.
 * Props:
 *  - variant: 1..4 (defaults to 1)
 *  - size: px width of the heart (defaults to 40)
 *  - rotate: degrees (defaults to 0)
 *  - className: extra classes (positioning, hidden md:block, etc.)
 *  - style: extra inline styles
 */
const HandHeart = ({
  variant = 1,
  size = 40,
  rotate = 0,
  className = "",
  style = {},
}) => {
  const src = HEART_SRCS[(variant - 1) % HEART_SRCS.length];
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={`pointer-events-none select-none ${className}`}
      style={{
        width: `${size}px`,
        height: "auto",
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    />
  );
};

export default HandHeart;
